import React, { useEffect, useRef, useState } from "react";
import { ImageModal } from "./Modals/ImageModal"

export const ProductCarousel = () => {
    const step = useRef(window.outerWidth >= 576 ? 80 : 60);
    const currThumb = useRef(0);
    const scrolling = useRef(false);
    const thumbLength = productModel.Images.length;
    const [bigImgName, setBigImgName] = useState("");

    useEffect(() => {
        $("#thumbs-container-h").width($("#slideshow").width());
        $("li > .thumbnail").css({ "min-width": step.current + "px" });
        if (window.outerWidth >= 576) {
            if ((productModel.Images.length * step.current + (productModel.Images.length - 1) * parseInt($("#thumbs-container-h .list-inline").css("gap"))) > parseInt($($('#thumbs-container-h')[0]).css('width'))) {
                $('#thumb-arrow-left').removeClass('d-none').addClass('d-flex');
                $('#thumb-arrow-right').removeClass('d-none').addClass('d-flex');
                $('#thumbs-container-h').find('ul').first().removeClass('px-2');
            }
            else $("#thumbs-container-h").css({ "justify-content": "center" });
        }

        $('.carousel').on('touchstart', function (event) {
            const xClick = event.originalEvent.touches[0].pageX;
            $(this).one('touchmove', function (event) {
                const xMove = event.originalEvent.touches[0].pageX;
                const sensitivityInPx = 5;

                if (Math.floor(xClick - xMove) > sensitivityInPx) {
                    $(this).carousel('next');
                    $(`img[data-thumbid="${currThumb.current}"]`).css('border-color', '#E0E0E0');
                    if (currThumb.current == thumbLength - 1) {
                        currThumb.current = 0;
                        $('#thumbs-container-h').animate({ scrollLeft: -1000 }, 1000);
                    }
                    else currThumb.current++;
                    $(`img[data-thumbid="${currThumb.current}"]`).css('border-color', '#282828');
                }
                else if (Math.floor(xClick - xMove) < -sensitivityInPx) {
                    $(this).carousel('prev');
                    $(`img[data-thumbid="${currThumb.current}"]`).css('border-color', '#E0E0E0');
                    if (currThumb.current == 0) {
                        currThumb.current = thumbLength - 1;
                        $('#thumbs-container-h').animate({ scrollLeft: 1000 }, 1000);
                    }
                    else currThumb.current--;
                    $(`img[data-thumbid="${currThumb.current}"]`).css('border-color', '#282828');
                }
            });
            $(this).on('touchend', function () {
                $(this).off('touchmove');
            });
        });
        return () => $('.carousel').on('touchstart', null)
    }, [])

    return (
        productModel.Images?.length > 0 && (
            <div className="product-images">
                {!!bigImgName && <ImageModal bigImgName={bigImgName} setBigImgName={setBigImgName} />}
                <div id="slideshow" className="carousel slide w-100 mw-100" data-ride="carousel" data-interval="false">
                    <div className="carousel-inner">
                        {productModel.RibbonText != null &&
                            <div className={"ribbon-label " + (productModel.LabelColor != null ? "ribbon-label-" + productModel.LabelColor.toLowerCase() : '')}>
                                <p><span>{productModel.RibbonText}</span></p>
                            </div>
                        }
                        {productModel.Images.map((img, i) =>
                            img.Type === "I" ?
                                <div key={`carousel-image-${i}`} className={`carousel-item ${i == 0 && 'active'}`}>
                                    <img className={`product-carousel-image ${i !== 0 && 'd-block img-fluid mx-auto'}`}
                                        style={{ height: "100%", aspectRatio: "4/3" }} loading="lazy"
                                        srcSet={`/Content/ProductImages/340x255/${img.ImageName} 338w,
                                                 /Content/ProductImages/384x288/${img.ImageName} 384w,
                                                 /Content/ProductImages/460x345/${img.ImageName} 459w,
                                                 /Content/ProductImages/960x720/${img.ImageName} 568w`}
                                        sizes="(max-width: 767px) 338px,
                                               (max-width: 992px) 459px,
                                               (max-width: 1200px) 384px,
                                               (max-width: 1399px) 459px,
                                               (min-width: 1400px) 568px,
                                               568px"
                                        src={`/Content/ProductImages/960x720/${img.ImageName}`}
                                        alt={`${img.AltText}`}
                                        title={`${img.ImageTag}`}
                                        onClick={() => { setBigImgName(img.ImageName) }} />
                                </div>
                                :
                                <div key={`carousel-image-${i}`} className={`carousel-item ${i == 0 && 'active'}`} style={{ cursor: "pointer" }} >
                                    <video className="d-block mx-auto tw-w-full"
                                        style={{ backgroundColor: "#000" }}
                                        poster={`/Content/ProductImages/460x345/${img.ImageName}`}
                                        controls alt={img.AltText} title={img.ImageTag}>
                                        <source src={`/Content/Videos/SD/${img.ImageName.substring(0, img.ImageName.length - 3)}mp4`} type="video/mp4" />
                                        Your browser does not support the video tag.
                                    </video>
                                </div>
                        )}
                    </div>
                </div>

                {/*Thumbnails*/}
                {productModel.Images.length > 1 &&
                    <div className="p-0 m-0 d-flex flex-row justify-content-center" id="scroll-container-h" >
                        <div id="thumb-arrow-left" className="mh-100 tw-text-[20px] sm:tw-text-[1.75rem] tw-cursor-pointer h3 justify-content-between p-0 m-0 d-none flex-column tw-text-[#A2A2A2] hover:tw-text-tamarillo-700"
                            onClick={leftArrowClick} onMouseEnter={() => { scrolling.current = true; scrollContentH("left") }} onMouseLeave={() => scrolling.current = false} >
                            <span className="my-auto"><i className="fas fa-chevron-left"></i></span>
                        </div>
                        <div id="thumbs-container-h" className="tw-py-[0.5rem] d-flex flex-row tw-overflow-auto sm:tw-overflow-hidden">
                            <ul className="list-inline d-flex flex-row p-0 m-0 tw-gap-[11px]" data-bind={`css: { 'px-2': ${productModel.Images.length > 5} }`}>
                                {productModel.Images.map((img, i) =>
                                    <li key={`carousel-thumbnail-${i}`} className="p-0 m-0 tw-cursor-pointer" data-target="#slideshow" data-slide-to={i}>
                                        <img data-thumbid={i} className={`tw-py-[7px] sm:tw-py-0 sm:tw-h-[60px] thumbnail ${img.Type !== 'I' && 'video-thumbs'}`}
                                            onClick={activateBorder}
                                            style={{ border: i === 0 ? "1px solid #282828" : "1px solid #E0E0E0" }}
                                            src={`/Content/ProductImages/80x60/${img.Type === 'I' ? img.ImageName : img.ImageName.substring(0, img.ImageName.length - 3) + 'jpg'}`}
                                            loading="lazy"
                                            alt={img.AltText}
                                            title={img.ImageTag} />
                                    </li>
                                )}
                            </ul>
                        </div>
                        <div id="thumb-arrow-right" className="mh-100 h3 tw-text-[20px] sm:tw-text-[1.75rem] tw-cursor-pointer justify-content-between p-0 m-0 d-none tw-text-[#A2A2A2] hover:tw-text-tamarillo-700" onClick={rightArrowClick}
                            onMouseEnter={() => { scrolling.current = true; scrollContentH("right") }} onMouseLeave={() => scrolling.current = false}>
                            <span className="my-auto"><i className="fas fa-chevron-right"></i></span>
                        </div>
                    </div>
                }
            </div>
        )
    );

    function activateBorder(e) {
        $(`img[data-thumbid="${currThumb.current}"]`).css('border-color', '#E0E0E0');
        $(e.target).css('border-color', '#282828');
        currThumb.current = $(e.target).data("thumbid")
    }

    function scrollContentH(direction) {
        var amount = (direction === "left" ? "-=1px" : "+=1px");
        $("#thumbs-container-h").animate({
            scrollLeft: amount
        }, 1, function () {
            if (scrolling.current) {
                scrollContentH(direction);
            }
        });
    }

    function leftArrowClick(event) {
        event.preventDefault();
        $('#thumbs-container-h').animate({
            scrollLeft: "-=" + step.current + "px"
        });
    }

    function rightArrowClick(event) {
        event.preventDefault();
        $('#thumbs-container-h').animate({
            scrollLeft: "+=" + step.current + "px"
        });
    }
}